'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import type { InputProps } from './Input.types';

import styles from './Input.module.scss';

export function Input({
  style,
  className,
  error,
  testId = 'ui-input',
  ref,
  ...rest
}: InputProps & { ref?: Ref<HTMLInputElement> }) {
  return (
    <input
      ref={ref}
      style={style}
      className={classnames(
        styles['input'],
        error && styles['input--error'],
        rest.disabled && styles['input--disabled'],
        className,
      )}
      data-testid={testId}
      {...rest}
    />
  );
}
